import { render, staticRenderFns } from "./InsertTransaction.vue?vue&type=template&id=1f5b6d38"
import script from "./InsertTransaction.vue?vue&type=script&lang=js"
export * from "./InsertTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports